<template>
  <div class="themeItem_medalTally_container">
    <div class="tableScrollArea" ref="tableParentDom">
      <compreSportsMeet_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :tableHeightPx="tableHeightPx"
        v-show="tableData && tableData.length > 0"
      ></compreSportsMeet_table>
      <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
    </div>
  </div>
</template>

<script>
// 奖牌榜 主题  【支持竖向滚动】
import cup_base_data_mixin from '@mixins/cup_base_data'
import compreSportsMeet_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
export default {
  name: 'themeItem_medalTally_container',
  mixins: [cup_base_data_mixin],
  components: {
    compreSportsMeet_table,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug(
          'themeItem_medalTally_container 重新刷新数据:',
          newVal,
          oldVal
        )
        if (newVal && newVal.data) {
          this.computedTableData(newVal.data.dataList)
        }
      },
      immediate: false,
      deep: true,
    },
  },
  data() {
    return {
      tableMode: 'themeItem_medalTally',
      parentWidthPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 20.83,
      tableCellDefaultWidthVw: null,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //默认全部展示
      // list: null,
      // list: [
      //   {
      //     seasonCode: 'ASG19',
      //     rankGold: 1,
      //     rankMedal: 1,
      //     organisationCode: 'CHN',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/CHN.png',
      //     organisationName: '中国',
      //     gold: 235,
      //     silver: 62,
      //     bronze: 44,
      //     medal: 341,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      //   {
      //     bronze: 42,
      //     gold: 24,
      //     medal: 96,
      //     organisationCode: 'KOR',
      //     organisationLogo:
      //       'https://hyper-sports-dev-res.mixtmt.com/Games/ASG19/organisations/KOR.png',
      //     organisationName: '韩国',
      //     rankGold: 2,
      //     rankMedal: 3,
      //     seasonCode: 'ASG19',
      //     silver: 30,
      //   },
      // ],
    }
  },
  //   watch: {
  //     datas(newVal, oldVal) {
  //       if (
  //         newVal &&
  //         JSON.stringify(newVal.data.dataList) !==
  //           JSON.stringify(oldVal.data.dataList)
  //       ) {
  //         this.list = this.computedMedalList(newVal.data.dataList)
  //       }
  //     },
  //     immediate: false,
  //     deep: true,
  //   },
  computed: {
    tableHeightPx() {
      // 等比的，所以固定写死
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375
      return Math.floor((clientWidth / 100) * (2.638 * 5.8 + 2.778))
      //   return 'auto'
    },
  },
  created() {},
  mounted() {
    this.computedTableData(this.datas.data.dataList)
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.$nextTick(() => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
      // console.debug('this.tableHeightPx:', this.tableHeightPx)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    computedTableData(data) {
      if (data) {
        this.tableTotal = data ? data.length : 0
        // 表头
        const columns = [
          {
            colKey: 'teamName',
            colTitle: '代表团',
          },
          {
            colKey: 'teamLogo',
            colTitle: '国旗',
          },
          {
            colKey: 'rankNum',
            colTitle: '金牌排名',
          },
          {
            colKey: 'joinNum',
            colTitle: '总数排名',
          },
          {
            colKey: 'gold',
            colTitle: '金牌',
          },
          {
            colKey: 'silver',
            colTitle: '银牌',
          },
          {
            colKey: 'bronze',
            colTitle: '铜牌',
          },
          {
            colKey: 'total',
            colTitle: '奖牌总数',
          },
          //   {
          //     colKey: 'arrowIcon',
          //     colTitle: '',
          //   },
        ]
        const fristColumns = columns.slice(0, 2)
        const otherColumns = columns.slice(2)
        this.defaultWidthVwNum = otherColumns.length - 0 //减去这2列[arrowIcon, isExpand]
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let fristColumnPropArr = []
          for (let i = 0; i < fristColumns.length; i++) {
            fristColumnPropArr.push(fristColumns[i].colKey)
          }
          const fristColumn = {
            prop: 'delegationLogo-delegationName', //fristColumnPropArr.join('-'),
            label: '参赛者',
            widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnNumLogoNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            if (i == 2) {
              tableColumnData.push(fristColumn)
            }
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? this.tableCellDefaultWidthVw / 2
                : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? 'expandTdClassName'
                : '', //单独定制的头部样式class
              selected: '',
            })
          }

          this.tableColumnData = tableColumnData
        }
        this.tableData = data
          ? data.map((delegation) => {
              let delegationItem = {
                id: delegation.organisationCode,
                delegationName: delegation.organisationName,
                delegationLogo: delegation.organisationLogo,
                rankNum: delegation.rankGold,
                joinNum: delegation.rankMedal,
                gold: delegation.gold,
                silver: delegation.silver,
                bronze: delegation.bronze,
                total: delegation.medal,
                arrowIcon: '',
                isHasDetailData: false, //正常只有获得奖牌的国家，在奖牌榜才会显示出来，控制是否有第一级展开
              }
              return delegationItem
            })
          : []
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_medalTally_container {
  width: 100%;
  padding: 0.694vw 0;
  .tableScrollArea {
    width: 100%;
  }
}
</style>
